<template>
  <div>
    <InfoHead />
    <div class="information-inf">
      <span>Fill in the real and effective information to pass the review</span>
    </div>
    <div class="information-context">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="date" style="width: 30%"></el-table-column>
        <el-table-column prop="name" align="right">
          <template slot-scope="scope">
            <el-input :disabled="changecolor" v-model="scope.row.name" placeholder="please input" type="text" />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="information-bottom" :class="{ 'changecolor': changecolor }" @click="Submit">Submit</div>
  </div>
</template>

<script>
import axios from "axios";
import InfoHead from "../components/InfoHead.vue";

export default {
  name: "",
  components: {
    InfoHead
  },
  data() {
    return {
      changecolor:false,
      updateInfo: true,
      tableData: [
        {
          date: "Address",
          name: ""
        },
        {
          date: "Monthly income",
          name: ""
        },
        {
          date: "Expected loan amount",
          name: ""
        },
        {
          date: "Loan purpose",
          name: ""
        },
        {
          date: "Married unmarried",
          name: ""
        },
        {
          date: "Education",
          name: ""
        }
      ]
    };
  },
  mounted() {
    this.getUserInform();
  },
  methods: {
    getUserInform() {
      let token = sessionStorage.getItem("token");
      // ////console.log(token)
      axios
        .get(`/puserSys/puser/selectInfo?id=${+token}`)
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.data[0] != null) {
              if (
              res.data.data[0].address != "" &&
              res.data.data[0].educationalbackground != "" &&
              res.data.data[0].expectedamount != "" &&
              res.data.data[0].marriage != "" &&
              res.data.data[0].monthlylncome != "" &&
              res.data.data[0].purpose != ""
              ) {
                var data = res.data.data[0];
                // ////console.log(res.data)
                (this.tableData[0].name = data.address),
                  (this.tableData[5].name = data.educationalbackground),
                  (this.tableData[2].name = data.expectedamount),
                  (this.tableData[4].name = data.marriage),
                  (this.tableData[1].name = data.monthlylncome),
                  (this.tableData[3].name = data.purpose);
                this.updateInfo = false;
                this.changecolor=true
              }
            }
            // ////console.log(this.tableData[0].name);
          } else {
            // ////console.log("用户信息查询失败")
          }
        })
        .catch(() => {});
    },
    Submit() {
      if (this.updateInfo) {
        let token = sessionStorage.getItem("token");
        if (
          this.tableData[0].name == "" ||
          this.tableData[5].name == "" ||
          this.tableData[2].name == "" ||
          this.tableData[4].name == "" ||
          this.tableData[1].name == "" ||
          this.tableData[3].name == ""
        ) {
          this.$message.error("Incomplete information");
          return;
        }

        axios
          .post("/puserSys/puser/updateInfo", {
            address: this.tableData[0].name,
            educationalbackground: this.tableData[5].name,
            expectedamount: this.tableData[2].name,
            marriage: this.tableData[4].name,
            monthlylncome: this.tableData[1].name,
            purpose: this.tableData[3].name,
            id: +token
          })
          .then(res => {
            try {
              if (res.data.msg == "操作成功") {
                this.$message({
                  type: "success",
                  message: "UPDATE SUCCESS"
                });
                this.$router.push("/MyProfileviews");
              } else {
                this.$message({
                  type: "error",
                  message: "UPDATE error"
                });
              }
            } catch {}
            // ////console.log(res);
          })
          .catch(() => {});
      } else {
        this.$message({
          type: "error",
          message: "User information already exists, please contact the administrator to modify it"
        });
        this.$router.push("/MyProfileviews");
      }
    }
  }
};
</script>

<style>
.information-inf {
  height: auto;
  background-color: #a95159;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  font-size: 15px;
  text-align: center;
  position: relative;
  padding: 5px 0 5px 10px;
  margin-top: 80px;
}

.information-context {
  margin-top: 10px;
  height: 600px;
}

.el-input {
  text-align: right;
}

.information-context .el-table__header-wrapper {
  display: none;
}

.information-bottom {
  width: 100%;
  position: fixed;
  z-index: 1000;
  bottom: 0;
  left: 0;
  color: #fff;
  height: 55px;
  line-height: 55px;
  text-align: center;
  font-size: 25px;
  background-color: #a95159;
  cursor: pointer;
}
.changecolor{
    background-color: #C0C4CC;
}
</style>
